<template>
  <div v-if="$auth.check(['SUPER'])">
    <b-card>
      <grid-filters
        grid-data="dsrPointsMonthNewGrid"
        :fields="gridFilters"
      ></grid-filters>
      <div class="text-right mb-3">
        <b-button
          variant="success"
          class="text-white"
          :disabled="exporting"
          v-on:click="exportGrid()"
          ><i v-show="!exporting" class="fa fa-download"></i
          ><i v-show="exporting" class="fa fa-spinner fa-spin"></i>
          Exportar</b-button
        >
      </div>
      <Grid
        ref="dsrPointsMonthNewGrid"
        name="dsrPointsMonthNewGrid"
        v-bind:url="url"
        v-bind:preload="preload"
        v-bind:columns="columns"
        :pageable="true"
        :filterable="true"
        :sortable="true"
        v-bind:schemaModelFields="schemaModelFields"
      ></Grid>
    </b-card>
    <b-modal ref="downloadModal" id="downloadModal">
      O ficheiro está pronto:
      <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
      <div slot="modal-footer" class="w-100">
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="hideModal"
        >
          Close
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";
import lists from "@/components/States.js";

export default {
  name: "UsersGrid",
  components: {
    Grid,
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: "",
        title: "",
      },
      gridFilters: [
        {
          field: "ym",
          type: "date",
          placeholder: "AnoMês (YYYYMM)",
          val: "",
        },
        {
          field: "dealer_id",
          modal: "dealers-new-modal",
          foreign: "id",
          placeholder: "Distribuidor",
        },
        {
          field: "dsr_id",
          modal: "dsr-new-modal",
          foreign: "id",
          placeholder: "DSR",
        },
      ],
      schemaModelFields: {
        created_at: {
          type: "date",
        },
        dealer_id: {
          type: "number",
        },
      },
      url: "pointsGlobal",
      preload: [
        {
          api: "dealersnew/lstnew",
          field: "dealer_id",
        },
      ],
      columns: [
        {
          field: "dsr_id",
          title: "DSR Id",
          width: "80px",
        },
        {
          field: "name",
          title: "Nome",
          width: "120px",
        },
        {
          field: "username",
          title: "Utilizador",
          width: "120px",
        },
        {
          field: "dealer_id",
          title: "Dist.",
          width: "120px",
        },
        {
          field: "email",
          title: "Email",
          width: "120px",
          values: [],
        },
        {
          field: "phone",
          title: "Telefone",
          width: "120px",
          format: "{0:n0}",
          sortable: false,
          filterable: false,
        },
        {
          field: "ym",
          title: "Ano/Mês",
          width: "120px",
          format: "{0:n0}",
          sortable: true,
          filterable: true,
        },
        {
          field: "pontos_criterios",
          title: "Pts critério",
          width: "120px",
          format: "{0:n0}",
          sortable: false,
          filterable: false,
        },
        {
          field: "pontos_campanhas",
          title: "Pts Campanha",
          width: "120px",
          format: "{0:n0}",
          sortable: false,
          filterable: false,
        },
        {
          field: "pontos_gastos",
          title: "Pts Gastos",
          width: "120px",
          format: "{0:n0}",
          sortable: false,
          filterable: false,
        },
        {
          field: "ufs",
          title: "Pts UFS",
          width: "120px",
          format: "{0:n0}",
          sortable: false,
          filterable: false,
        },
        {
          field: "gallo",
          title: "Pts Gallo",
          width: "120px",
          format: "{0:n0}",
          sortable: false,
          filterable: false,
        },
        // {
        //   field: "created_at",
        //   title: "Criado em:",
        //   width: "120px",
        //   format: "{0:n0}",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          field: "total",
          title: "Total",
          width: "120px",
          sortable: false,
          filterable: false,
          template: function (dataItem) {
            const criterios = parseFloat(dataItem.pontos_criterios) || 0;
            const campanhas = parseFloat(dataItem.pontos_campanhas) || 0;
            const gastos = parseFloat(dataItem.pontos_gastos) || 0;
            return criterios + campanhas - gastos;
          },
        },
      ],
    };
  },
  methods: {
    hideModal: function () {
      this.$refs.downloadModal.hide();
    },
    exportGrid: function () {
      this.exporting = true;
      var grid = this.$refs.dsrPointsMonthNewGrid.$refs.mygrid.kendoWidget();
      console.log(grid.getOptions());
      this.axios
        .post(this.url + "/exportglobal", {
          filter: grid.getOptions().dataSource.filter,
        })
        .then((response) => {
          this.fileDownload = response.data;
          this.$refs.downloadModal.show();
          this.exporting = false;
        })
        .catch((error) => {
          this.$bvToast.toast("Houve um erro a exportar", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.exporting = false;
        });
    },
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: "dsr_points.edit",
        params: {
          id: item.id,
        },
      });
      if (this.$auth.check("dsr_points.edit")) {
        return (
          '<a href="' +
          route.href +
          '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
        );
      }
      return "";
    },
  },
};
</script>
